<template>
  <div class="ui-highlight-subtext">
    <span
      v-for="(text, index) in textList"
      :key="`key-${index}`"
      :style="getStyle(index)"
      v-text="text"
    />
  </div>
</template>

<script>
import colors from '../libs/colors'

export default {
  props: {
    text: String,
    subtext: String,
    color: {
      type: String,
      default: colors.orange1
    }
  },
  computed: {
    textList () {
      if (!this.subtext) return [this.text]
      if (!this.text) return []
      return this.text.split(new RegExp(`(${this.subtext})`, 'gi'))
    },
    styleList () {
      return {
        color: this.color
      }
    }
  },
  methods: {
    getStyle (index) {
      return index % 2 ? this.styleList : null
    }
  }
}
</script>
